<script>
    import * as m from '@app/paraglide/messages.js';
    import { showModal } from '@app/store/modalStore.svelte.js';
    import { projectState, updateSelectedEventGroup } from '@app/store/projectStore.svelte.js';
    import { isEventGroupLocked } from '@app/store/eventGroupStore.svelte.js';
    import EventGroupIcons from './EventGroupIcons.svelte';

    /** @type {{name: string, eventGroupIndex: number, eventGroupType: string}} */
    let { name, eventGroupIndex, eventGroupType } = $props();

    let isLocked = $derived(isEventGroupLocked(eventGroupIndex));
    
    async function selectEventGroup() {
        updateSelectedEventGroup(eventGroupIndex);
    }

    function showEventGroupOptions(event) {
        event.stopPropagation();
        projectState.selected = eventGroupIndex;
        showModal("eventGroupOptions");
    }
</script>

<button
    type="button"
    id={"eventGroupTab-" + eventGroupIndex}
    aria-label={m.editor_select_event_group({name})}
    class="btn nav-link btn-link rounded-0 rounded-top {projectState.selected === eventGroupIndex ? 'active bg-light bg-gradient border-light shadow fw-bold' : ''}"
    onclick={() => selectEventGroup()}
>
    <EventGroupIcons type={eventGroupType} /> {name.substring(0,50)}
    {#if isLocked}
        <i class="bi bi-lock-fill text-warning ms-1 event-group-lock-icon" title={m.edit_event_group_lock_label()} aria-hidden="true"></i>
    {/if}
    <div class="float-end">
        <a 
            aria-label={m.editor_event_group_options()}
            href="#!/"
            class="btn btn-link ms-3 p-0 {projectState.selected === eventGroupIndex ? 'text-dark' : ''}" 
            role="button" 
            tabindex="0" 
            onclick={(e) => showEventGroupOptions(e)}
        >
            <i class="bi bi-three-dots-vertical p-2"></i>
        </a>
    </div>
</button>

<style>
.event-group-lock-icon {
    font-size: 0.7em;
    vertical-align: middle;
}
</style>
